// src/hooks/useTokenSearch.ts

import { useQuery } from "@tanstack/react-query";
import { useEffect, useMemo, useState } from "react";
import { searchTokensQueryOptions } from "@/services/queries/searchQueries";
import type { SearchToken } from "@/types/search";

export interface UseTokenSearchResult {
  results: SearchToken[];
  isLoading: boolean;
  isError: boolean;
}

export function useTokenSearch(query: string): UseTokenSearchResult {
  const trimmed = query.trim();

  const [debounced, setDebounced] = useState(trimmed);
  useEffect(() => {
    const handle = setTimeout(() => setDebounced(trimmed), 200);
    return () => clearTimeout(handle);
  }, [trimmed]);

  const enabled = debounced.length >= 2;

  const { data, isLoading, isError } = useQuery({
    ...searchTokensQueryOptions(debounced, 10),
    enabled,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
    retry: 1,
  });

  const results = useMemo(() => data?.data ?? [], [data]);

  return { results, isLoading, isError };
}


